import React from "react";

const Users = ({ fill }: { fill: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 19.5C17 17.843 14.761 16.5 12 16.5C9.239 16.5 7 17.843 7 19.5M21 16.5C21 15.27 19.766 14.213 18 13.75M3 16.5C3 15.27 4.234 14.213 6 13.75M18 9.736C18.2963 9.47409 18.5378 9.15619 18.7108 8.80059C18.8838 8.445 18.9847 8.05871 19.0079 7.66396C19.031 7.2692 18.9759 6.87377 18.8456 6.50039C18.7154 6.12702 18.5127 5.78307 18.249 5.48834C17.9854 5.1936 17.6661 4.9539 17.3095 4.783C16.9529 4.61211 16.5661 4.51339 16.1712 4.49255C15.7763 4.4717 15.3812 4.52912 15.0086 4.66151C14.636 4.79391 14.2932 4.99866 14 5.264M6 9.736C5.4123 9.20414 5.05896 8.46132 5.01717 7.6698C4.97538 6.87827 5.24853 6.10237 5.77696 5.51159C6.30539 4.9208 7.04614 4.56315 7.83741 4.51676C8.62868 4.47037 9.40616 4.73901 10 5.264M12 13.5C11.2044 13.5 10.4413 13.1839 9.87868 12.6213C9.31607 12.0587 9 11.2956 9 10.5C9 9.70435 9.31607 8.94129 9.87868 8.37868C10.4413 7.81607 11.2044 7.5 12 7.5C12.7956 7.5 13.5587 7.81607 14.1213 8.37868C14.6839 8.94129 15 9.70435 15 10.5C15 11.2956 14.6839 12.0587 14.1213 12.6213C13.5587 13.1839 12.7956 13.5 12 13.5Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Users;
